import Information from "../Information/Information";
import { useTranslation } from "react-i18next";
import Document from "../Documents/Document";
import Media from "../Media/Media";
import NotifyMe from "../../../NotifyMe/NotifyMe";
import PresaleDetailCard from "../../PresaleDetailCard";

const Banner = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="banner-detailpage banner-detailpagematchain">
        <img
          src="\assets\alldetailpages\xprotocol\banner-bg.png"
          alt="img"
          className="img-fluid banner-bg"
        />
        <img
          src="\assets\alldetailpages\xprotocol\banner-bgmbl.png"
          alt="img"
          className="img-fluid d-none banner-mbl-bg h-100"
          style={{ objectPosition: "left" }}
        />
      </section>
      <section className="bottom-part-section">
        <div className="custom-container">
          <div className="parent">
            <PresaleDetailCard presaleName={"XProtocol"} t={t} />
            <div className="right-side">
              <ul class="nav nav-tabs banner-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="true"
                  >
                    {t("Gems-detailt2")}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="document-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#document-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="document-tab-pane"
                    aria-selected="false"
                  >
                    {t("Gems-detailt4")}
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">{t('Gems-detailt3')}</button>
                </li>
              </ul>
              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="home-tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                  tabindex="0"
                >
                  <Information />
                </div>
                <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0"><Media /></div>
                <div
                  class="tab-pane fade"
                  id="document-tab-pane"
                  role="tabpanel"
                  aria-labelledby="document-tab"
                  tabindex="0"
                >
                  <Document />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  );
};

export default Banner;